import React from 'react';
import { VariableSizeList } from 'react-window';

import useMediaQuery from '@mui/material/useMediaQuery';

import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';

import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { useTheme } from '@mui/material/styles';


const LISTBOX_PADDING = 8;

const renderRow = (props) => {
    const { data, index, style } = props;
    const dataSet = data[index];
    const inlineStyle = {
        ...style,
        top: style.top + LISTBOX_PADDING
    };

    return (
        <Typography component="li" {...dataSet[0]} noWrap sx={inlineStyle}>
            {dataSet[1].code} - {dataSet[1].libelle}
        </Typography>
    );
}

const OuterElementContext = React.createContext({});

const OuterElementType = React.forwardRef((props, ref) => {
    const outerProps = React.useContext(OuterElementContext);
    return <div ref={ref} {...props} {...outerProps} />;
});

OuterElementType.displayName = "OuterElementType";

const useResetCache = (data) => {
    const ref = React.useRef(null);
    React.useEffect(() => {
        if (ref.current != null) {
            ref.current.resetAfterIndex(0, true);
        }
    }, [data]);
    return ref;
}

// Adapter for react-window
const ListboxComponent = React.forwardRef(function ListboxComponent(props, ref) {
    const { children, ...other } = props;
    const itemData = [];
    children.forEach((item) => {
        itemData.push(item);
        itemData.push(...(item.children || []));
    });

    const theme = useTheme();
    const smUp = useMediaQuery(theme.breakpoints.up('sm'), {
        noSsr: true,
    });

    const itemCount = itemData.length;

    const itemSize = smUp ? 36 : 48;
    const getChildSize = () => {
        return itemSize;
    };

    const getHeight = () => {
        if (itemCount > 8) {
            return 8 * itemSize;
        }
        return itemData.map(getChildSize).reduce((a, b) => a + b, 0);
    };

    const gridRef = useResetCache(itemCount);

    return (
        <div ref={ref}>
            <OuterElementContext.Provider value={other}>
                <VariableSizeList
                    itemData={itemData}
                    width="100%"
                    height={getHeight() + 2 * LISTBOX_PADDING}
                    ref={gridRef}
                    outerElementType={OuterElementType}
                    innerElementType="ul"
                    overscanCount={5}
                    itemSize={(index) => getChildSize(itemData[index])}
                    itemCount={itemCount}
                >
                    {renderRow}
                </VariableSizeList>
            </OuterElementContext.Provider>
        </div>
    );
});


const MyAutocompleteVirtualize = ({ options, value, onChange, label, placeholder }) => {

    const filterOptions = createFilterOptions({
        matchFrom: 'any',
        stringify: (option) => `${option.code} - ${option.libelle}`,
    });

    return (
        <Autocomplete
            id="liste-codes"
            disableListWrap
            options={options}
            sx={{ width: 400, mb: 2 }}
            renderInput={(params) =>
                <TextField
                    {...params}
                    label={label}
                    placeholder={placeholder}
                />}
            renderOption={(props, option) => [props, option]}
            value={value}
            onChange={onChange}
            ListboxComponent={ListboxComponent}
            filterOptions={filterOptions}
            getOptionLabel={(option) => (option ? `${option.code} - ${option.libelle}` : "")}
        />
    )
}

export default MyAutocompleteVirtualize;